module.exports = __webpack_public_path__ + "img/04f12d833eb5cef3c16893bd747788fa.png";